import React from 'react'

const TableLoader = ({ colSpan }) => {
  return (
    <tbody>
      {
        [...Array(3).keys()]?.map((key) => (
          <tr key={'row' + key}>
            <td colSpan={colSpan}>
              <p className="placeholder-glow">
                <span className="placeholder col-12"></span>
              </p>
            </td>
          </tr>
        ))
      }

    </tbody>
  )
}

export default TableLoader
